const XA_FETCH_DOWNLOADINFO = 'XA_FETCH_DOWNLOADINFO';
const XA_FETCH_SUPPORTED_AGENT_VERSIONS = 'XA_FETCH_SUPPORTED_AGENT_VERSIONS';
const XA_FETCH_USERKEY = 'XA_FETCH_USERKEY';
const XA_FETCH_AGENTS = 'XA_FETCH_AGENTS';
const XA_POLL_CONNECTION_STATUS = 'XA_POLL_CONNECTION_STATUS';
const XA_DELETE_AGENT = 'XA_DELETE_AGENT';
const XA_SAVE_NAME = 'XA_SAVE_NAME';
const IA_FETCH_AGENTS = 'IA_FETCH_AGENTS';
const IA_DELETE_AGENT = 'IA_DELETE_AGENT';
const IA_SAVE_NAME = 'IA_SAVE_NAME';
const IA_POLL_CONNECTION_STATUS = 'IA_POLL_CONNECTION_STATUS';
const XA_POLL_NEW_INSTALL = 'XA_POLL_NEW_INSTALL';
const XA_UPDATE_AGENT_MONITORS = 'XA_UPDATE_AGENT_MONITORS';
const XA_UPDATE_AGENT_OWNERS = 'XA_UPDATE_AGENT_OWNERS';

export const XA_FETCH_DOWNLOADINFO_POST = `${XA_FETCH_DOWNLOADINFO}_START`;
export const XA_FETCH_DOWNLOADINFO_SUCCESS = `${XA_FETCH_DOWNLOADINFO}_SUCCESS`;
export const XA_FETCH_DOWNLOADINFO_FAILURE = `${XA_FETCH_DOWNLOADINFO}_FAIL`;

export const XA_FETCH_SUPPORTED_AGENT_VERSIONS_POST = `${XA_FETCH_SUPPORTED_AGENT_VERSIONS}_START`;
export const XA_FETCH_SUPPORTED_AGENT_VERSIONS_SUCCESS = `${XA_FETCH_SUPPORTED_AGENT_VERSIONS}_SUCCESS`;
export const XA_FETCH_SUPPORTED_AGENT_VERSIONS_FAILURE = `${XA_FETCH_SUPPORTED_AGENT_VERSIONS}_FAIL`;

export const XA_FETCH_USERKEY_POST = `${XA_FETCH_USERKEY}_START`;
export const XA_FETCH_USERKEY_SUCCESS = `${XA_FETCH_USERKEY}_SUCCESS`;
export const XA_FETCH_USERKEY_FAILURE = `${XA_FETCH_USERKEY}_FAIL`;

export const XA_FETCH_AGENTS_POST = `${XA_FETCH_AGENTS}_START`;
export const XA_FETCH_AGENTS_SUCCESS = `${XA_FETCH_AGENTS}_SUCCESS`;
export const XA_FETCH_AGENTS_FAILURE = `${XA_FETCH_AGENTS}_FAIL`;

export const XA_POLL_CONNECTION_STATUS_POST = `${XA_POLL_CONNECTION_STATUS}_START`;
export const XA_POLL_CONNECTION_STATUS_SUCCESS = `${XA_POLL_CONNECTION_STATUS}_SUCCESS`;
export const XA_POLL_CONNECTION_STATUS_FAILURE = `${XA_POLL_CONNECTION_STATUS}_FAIL`;

export const XA_SAVE_NAME_POST = `${XA_SAVE_NAME}_START`;
export const XA_SAVE_NAME_SUCCESS = `${XA_SAVE_NAME}_SUCCESS`;
export const XA_SAVE_NAME_FAILURE = `${XA_SAVE_NAME}_FAIL`;

export const XA_DELETE_AGENT_POST = `${XA_DELETE_AGENT}_START`;
export const XA_DELETE_AGENT_SUCCESS = `${XA_DELETE_AGENT}_SUCCESS`;
export const XA_DELETE_AGENT_FAILURE = `${XA_DELETE_AGENT}_FAIL`;

export const XA_POLL_NEW_INSTALL_POST = `${XA_POLL_NEW_INSTALL}_START`;
export const XA_POLL_NEW_INSTALL_SUCCESS = `${XA_POLL_NEW_INSTALL}_SUCCESS`;
export const XA_POLL_NEW_INSTALL_FAILURE = `${XA_POLL_NEW_INSTALL}_FAIL`;

export const XA_UPDATE_AGENT_MONITORS_POST = `${XA_UPDATE_AGENT_MONITORS}_START`;
export const XA_UPDATE_AGENT_MONITORS_SUCCESS = `${XA_UPDATE_AGENT_MONITORS}_SUCCESS`;
export const XA_UPDATE_AGENT_MONITORS_FAILURE = `${XA_UPDATE_AGENT_MONITORS}_FAIL`;

export const IA_FETCH_AGENTS_POST = `${IA_FETCH_AGENTS}_START`;
export const IA_FETCH_AGENTS_SUCCESS = `${IA_FETCH_AGENTS}_SUCCESS`;
export const IA_FETCH_AGENTS_FAILURE = `${IA_FETCH_AGENTS}_FAIL`;

export const IA_POLL_CONNECTION_STATUS_POST = `${IA_POLL_CONNECTION_STATUS}_START`;
export const IA_POLL_CONNECTION_STATUS_SUCCESS = `${IA_POLL_CONNECTION_STATUS}_SUCCESS`;
export const IA_POLL_CONNECTION_STATUS_FAILURE = `${IA_POLL_CONNECTION_STATUS}_FAIL`;

export const IA_SAVE_NAME_POST = `${IA_SAVE_NAME}_START`;
export const IA_SAVE_NAME_SUCCESS = `${IA_SAVE_NAME}_SUCCESS`;
export const IA_SAVE_NAME_FAILURE = `${IA_SAVE_NAME}_FAIL`;

export const IA_DELETE_AGENT_POST = `${IA_DELETE_AGENT}_START`;
export const IA_DELETE_AGENT_SUCCESS = `${IA_DELETE_AGENT}_SUCCESS`;
export const IA_DELETE_AGENT_FAILURE = `${IA_DELETE_AGENT}_FAIL`;

export const XA_UPDATE_AGENT_OWNERS_POST = `${XA_UPDATE_AGENT_OWNERS}_START`;
export const XA_UPDATE_AGENT_OWNERS_SUCCESS = `${XA_UPDATE_AGENT_OWNERS}_SUCCESS`;
export const XA_UPDATE_AGENT_OWNERS_FAILURE = `${XA_UPDATE_AGENT_OWNERS}_FAIL`;

export const XA_CHANGE_PLATFORM = 'XA_CHANGE_PLATFORM';
export const XA_NEW_AGENT_HANDLED = 'XA_NEW_AGENT_HANDLED';
export const XA_ACTIVE_TAB = 'XA_ACTIVE_TAB';

export const IA_TOGGLE_SHOW_DETAIL = 'IA_TOGGLE_SHOW_DETAIL';
export const IA_TOGGLE_SHOW_ALL_DETAILS = 'IA_TOGGLE_SHOW_ALL_DETAILS';

export const XA_RESET = 'XA_RESET';
export const XA_PAUSE_REFRESHING = 'XA_PAUSE_REFRESHING';

export function xAgentSaveNamePost(id, name) {
  const body = { id, name };
  return {
    type: XA_SAVE_NAME,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/agents',
      params: body,
      method: 'post',
    },
  };
}

export function xAgentFetchDownloadInfoPost() {
  return {
    type: XA_FETCH_DOWNLOADINFO,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/agent-installers/current',
      method: 'get',
    },
  };
}

export function xAgentFetchSupportedAgentVersions() {
  return {
    type: XA_FETCH_SUPPORTED_AGENT_VERSIONS,
    meta: {
      hyrax: true,
      uri: '/api/integration/1/info',
      method: 'get',
    },
  };
}

export function xAgentFetchUserKey(id) {
  return {
    type: XA_FETCH_USERKEY,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${id}/api-keys`,
      method: 'get',
      params: {
        type: 'XAGENT',
      },
    },
  };
}

export function xAgentFetchAgentsPost(status) {
  return {
    type: XA_FETCH_AGENTS,
    filterStatus: status,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/agents?status=${status}&embed=monitors.recipient`,
      method: 'get',
    },
  };
}

export function xAgentDeletePost(id) {
  const encodedId = encodeURIComponent(id);
  return {
    type: XA_DELETE_AGENT,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/agents/${encodedId}`,
      method: 'del',
    },
  };
}

export function xAgentChangePlatform(toPlatform) {
  return {
    type: XA_CHANGE_PLATFORM,
    toPlatform,
  };
}

export function xAgentPollNewInstall(user) {
  return {
    type: XA_POLL_NEW_INSTALL,
    loginUser: user,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/agents?status=SHOW_ALL',
      method: 'get',
    },
  };
}

export function newAgentHandled() {
  return {
    type: XA_NEW_AGENT_HANDLED,
  };
}

export function xAgentsActiveTab(index) {
  return {
    type: XA_ACTIVE_TAB,
    activeIndex: index,
  };
}

export function xAgentPollConnectionStatus(status) {
  return {
    type: XA_POLL_CONNECTION_STATUS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/agents?status=${status}&embed=monitors.recipient`,
      method: 'get',
    },
  };
}

export function reset() {
  return {
    type: XA_RESET,
  };
}

export function xAgentUpdateAgentMonitors(agentId, recipients) {
  const monitors = recipients.map(m => ({
    id: m.id,
  }));

  return {
    type: XA_UPDATE_AGENT_MONITORS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/agents/${agentId}/monitors`,
      method: 'put',
      params: { monitors },
    },
  };
}

export function xAgentPauseRefreshing(pause) {
  return {
    type: XA_PAUSE_REFRESHING,
    pause,
  };
}

/*
 * Legacy Integration Agents
 */
export function integrationAgentSaveNamePost(id, name) {
  const body = { id, name };
  return {
    type: IA_SAVE_NAME,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/integration-agents',
      params: body,
      method: 'post',
    },
  };
}

export function integrationAgentFetchAgentsPost(status) {
  return {
    type: IA_FETCH_AGENTS,
    filterStatus: status,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/integration-agents?status=${status}`,
      method: 'get',
    },
  };
}

export function integrationAgentDeletePost(id) {
  const encodedId = encodeURIComponent(id);
  return {
    type: IA_DELETE_AGENT,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/integration-agents/${encodedId}`,
      method: 'del',
    },
  };
}

export function integrationAgentToggleShowDetail(toggleId) {
  return {
    type: IA_TOGGLE_SHOW_DETAIL,
    id: toggleId,
  };
}

export function integrationAgentToggleShowAllDetails() {
  return {
    type: IA_TOGGLE_SHOW_ALL_DETAILS,
  };
}

export function integrationAgentPollConnectionStatus(status) {
  return {
    type: IA_POLL_CONNECTION_STATUS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/integration-agents?status=${status}`,
      method: 'get',
    },
  };
}

export function xAgentUpdateAgentOwners(agent) {
  return {
    type: XA_UPDATE_AGENT_OWNERS,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/agents',
      method: 'post',
      params: agent,
    },
  };
}
